import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Modal } from "src/modules/section/services/modal.service";

@Component({
    selector: "table-default-seach-modal",
    templateUrl: "default-search-modal.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableDefaultSearchModalComponent implements OnInit {

    public modal: Modal.IModal;

    public columns: { name: string, value: string }[] = [];

    public formGroup: FormGroup = new FormGroup({});

    public constructor(
        private changeDetectorRef: ChangeDetectorRef,
    ) {
    }


    private prepareForm(): void {
        if (!this.modal.params.searchIn) {
            return;
        }
        this.columns = this.modal.params?.searchIn;

        const selected: string[] = Array.isArray(this.modal.params?.selected)
            ? this.modal.params.selected
            : [];

        const groupControls: { [key: string]: FormControl } = {};
        for (const col of this.columns) {
            groupControls[col.value] = new FormControl(selected.includes(col.value));
        }
        this.formGroup = new FormGroup(groupControls);
        this.changeDetectorRef.markForCheck();
    }

    public getControl(key: string): FormControl {
        return this.formGroup && (this.formGroup.controls as any)[key] as FormControl;
    }

    public async submitForm(): Promise<any> {
        const selected: string[] = Object.keys(this.formGroup.value)
            .filter((key: string): boolean => !!this.formGroup.value[key]);

        this.modal.response.emit({
            name: "search_in",
            value: selected
        });
    }

    public close(): void {
        this.modal.response.next(null);
    }

    public ngOnInit(): void {
        this.prepareForm();
    }

}